const documentFoldersActions = {
  ITEM_FOLDERS_STATE_INIT: 'ITEM_FOLDERS_STATE_INIT',
  ITEM_FOLDERS_LIST_SET: 'ITEM_FOLDERS_LIST_SET'
};
export default documentFoldersActions;
